import { Redirect } from "react-router-dom";
import { useStepContext } from "./StepProvider";

export const EnrollmentRedirect: React.FC = () => {
  const { active } = useStepContext();
  return <Redirect to={active} />;
};
